module.exports = __webpack_public_path__ + "img/click_collect_service.f244477e.svg";